import {
  AbsenceType,
  ContentDocumentLinkDataFragment,
  MyAbsencesQuery,
} from '../../__generated__/graphql';
import { DocumentFile } from './types';
import { mapDeleteDisabled } from './MyAbsences/mappings';
import { startOfDay } from 'date-fns';

export const mapDocumentFile = (
  link: ContentDocumentLinkDataFragment,
): DocumentFile => ({
  id: link.Id,
  fileName: link.ContentDocument.Title
    ? `${link.ContentDocument.Title}.${link.ContentDocument.FileExtension}`
    : link.ContentDocument.Title,
  downloadPublicUrl: link.downloadUrl,
});

export const mapUpcomingAbsences = (
  absences: MyAbsencesQuery['me']['upcomingAbsences'],
) => {
  const currentStartOfDay = startOfDay(new Date());
  return absences.map((absence) => {
    const isHourly = absence.category.flair__Type__c === AbsenceType.Hourly;
    return {
      ...absence,
      ...mapDeleteDisabled(currentStartOfDay, absence.flair__Start_Date__c),
      isHourly,
      isMultiDay: absence.flair__Start_Date__c !== absence.flair__End_Date__c,
    };
  });
};
